import MiddleBlock from "../../../../components/MiddleBlock/MiddleBlock"
import styles from "./InfoBlock.module.css"
import background from "../../../../images/info_block_bg.png"

export default function InfoBlock() {
    return (
        <div className={ styles.container }>
            <img src={ background } alt="" aria-hidden="true" />
            <MiddleBlock>
                <div className={ styles.textBlock }>
                    <div className="">
                        <h1>
                            Twoja <span>muzyka.</span><br></br>
                            <span>Twoja</span> pasja.
                        </h1>
                        <p>
                            Wysokiej jakości instrumenty dla początkujących i profesjonalistów. Znajdź brzmienie, które wyraża Ciebie.
                        </p>
                    </div>
                </div>
            </MiddleBlock>
        </div>
    )
}
